export const imports = {
  'srcdocs/getstarted.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "srcdocs-getstarted" */ 'srcdocs/getstarted.mdx'
    ),
  'srcdocs/components/Page/page.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "srcdocs-components-page-page" */ 'srcdocs/components/Page/page.mdx'
    ),
  'srcdocs/components/Presentations/presentation.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "srcdocs-components-presentations-presentation" */ 'srcdocs/components/Presentations/presentation.mdx'
    ),
  'srcdocs/components/Wrapper/wrapper.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "srcdocs-components-wrapper-wrapper" */ 'srcdocs/components/Wrapper/wrapper.mdx'
    ),
}
